import "./style.scss";
import {ClipLoader} from "react-spinners";
import React from "react";

const LoadingSpinner = (props) => {
  return <div className='loading-spinner'><ClipLoader /></div>
}

export default LoadingSpinner;